import React from 'react';
import { CardContent, Stack } from '@mui/material';
import VendorIdentificationSection from './VendorIdentificationSection';
import VendorContactSection from './VendorContactSection';

export const VendorCreateForm: React.FC = () => {
  return (
    <CardContent sx={{ p: 3, backgroundColor: '#ffffff' }}>
      <Stack spacing={2.5}>
        <VendorIdentificationSection />
        <VendorContactSection />
      </Stack>
    </CardContent>
  );
};

export default VendorCreateForm;
